/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import {
  Button,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Modal,
  Backdrop,
  Fade,
  Paper,
} from '@material-ui/core';

const text = {
  sectionHeader: 'Stay up to date with',
  sectionSubHeader: 'the Nia Blog',
  emailPermission: 'I agree to let Nia send me promotional emails and updates.',
};

const styles = theme => ({
  content: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    boxSizing: 'border-box',
    width: '600px',
    maxWidth: 'calc(100% - 80px)',
    maxHeight: 'calc(100% - 80px)',
    padding: theme.spacing(4),
    [theme.breakpoints.down(600)]: {

    },
  },
  sectionHeader: {
    textAlign: 'center',
    paddingBottom: theme.spacing(4),
  },
  infusionForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '20vh',
  },
  infusionFieldInput: {
    margin: theme.spacing(1),
  },
  emailPermission: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    fontSize: '.8em',
  },
  formControlLabel: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  horizontalFields: {
    textAlign: 'center',
  },
});

class BlogSubscribeModal extends React.Component {
  constructor(props) {
    super(props);

    const { email } = this.props;

    this.state = {
      inf_field_FirstName: '',
      inf_field_Email: email,
      checked: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleCheck(e) {
    this.setState({ checked: e.target.checked });
  }

  render() {
    const {
      classes,
      open,
      onClose,
    } = this.props;
    const {
      inf_field_FirstName,
      inf_field_Email,
      checked,
    } = this.state;

    function canSubmit() {
      if (inf_field_FirstName !== '' && inf_field_Email !== '' && checked) {
        return true;
      }
      return false;
    }

    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Paper className={classes.content}>
            <Typography className={classes.sectionHeader} color="textSecondary" variant="h4">
              <span>{text.sectionHeader}</span>
              <br />
              <span>{text.sectionSubHeader}</span>
            </Typography>
            <form acceptCharset="UTF-8" action="https://sp877.infusionsoft.com/app/form/process/72dfee17c539246c893948bd258839e3" className={classes.infusionForm} id="inf_form_72dfee17c539246c893948bd258839e3" method="POST">
              <input name="inf_form_xid" type="hidden" value="72dfee17c539246c893948bd258839e3" />
              <input name="inf_form_name" type="hidden" value="BLOG SUBSCRIBE" />
              <input name="infusionsoft_version" type="hidden" value="1.70.0.453309" />
              <div className={classes.horizontalFields}>
                <TextField
                  required
                  className={classes.infusionFieldInput}
                  id="inf_field_FirstName"
                  name="inf_field_FirstName"
                  placeholder="First Name *"
                  type="text"
                  variant="outlined"
                  value={inf_field_FirstName}
                  onChange={this.handleChange}
                />
              </div>
              <TextField
                required
                className={classes.infusionFieldInput}
                id="inf_field_Email"
                name="inf_field_Email"
                placeholder="Email *"
                type="text"
                variant="outlined"
                value={inf_field_Email}
                onChange={this.handleChange}
              />
              <FormControlLabel
                className={classes.formControlLabel}
                control={<Checkbox checked={checked} onChange={this.handleCheck} />}
                label={text.emailPermission}
              />
              <Button disabled={!canSubmit()} color="secondary" variant="outlined" size="large" className="infusion-recaptcha" id="recaptcha_9381acb994eee503ac6b0e05a1dfa39a" type="submit">Submit</Button>
            </form>
            <script type="text/javascript" src="https://sp877.infusionsoft.app/app/webTracking/getTrackingCode" />
            <script type="text/javascript" src="https://sp877.infusionsoft.com/resources/external/recaptcha/production/recaptcha.js?b=1.70.0.453309-hf-202203291431" />
            <script src="https://www.google.com/recaptcha/api.js?onload=onloadInfusionRecaptchaCallback&render=explicit" async="async" defer="defer" />
            <script type="text/javascript" src="https://sp877.infusionsoft.com/app/timezone/timezoneInputJs?xid=72dfee17c539246c893948bd258839e3" />
            <script type="text/javascript" src="https://sp877.infusionsoft.com/js/jquery/jquery-3.3.1.js" />
            <script type="text/javascript" src="https://sp877.infusionsoft.app/app/webform/overwriteRefererJs" />
          </Paper>
        </Fade>
      </Modal>
    );
  }
}

BlogSubscribeModal.defaultProps = {
  email: '',
};

BlogSubscribeModal.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  email: PropTypes.string,
};

export default withStyles(styles)(BlogSubscribeModal);
